import React from "react";
//import { collapseToast } from "react-toastify";
import {ReactComponent as PythonIcon} from '../python-brands-solid.svg';

const Services = ({ classicHeader, darkTheme }) => {
  const iconColor = darkTheme ? "#ffffff" : "#000000e5";
  // services details
  const services = [
    {
      name: "Python Development Backend",
      desc: (
        <>
          Design and build scalable, secure back-end systems using Python, Django, and Pyramid frameworks.
          <br />
          Skilled in REST API design, automation, and integrating microservices across distributed environments.
        </>
      ),
      Icon: PythonIcon,
    },
    {
      name: "Full-Stack Web Development",
      desc: (
        <>
          Develop end-to-end web applications with React, TypeScript, and modern UI frameworks.
          <br />
          Experienced in building responsive, component-driven interfaces that connect seamlessly with backend APIs.
        </>
      ),
      icon: "fas fa-laptop-code fa-lg",
    },
    {
      name: "Cloud and DevOps Solutions",
      desc: (
        <>
          Deploy and manage applications in AWS and Azure environments.
          <br />
          Experienced in Docker, CI/CD pipelines, Jenkins, and GitHub Actions automating delivery and ensuring reliability.
        </>
      ),
      icon: "fas fa-cloud fa-lg",
    },
    {
      name: "Network Systems & Automation",
      desc: (
        <>
          Combine software and networking expertise to create resilient systems for device management, routing, and monitoring.
          <br />
          Familiar with CCNA-level networking, VPNs, DHCP, and system administration.
        </>
      ),
      icon: "fas fa-network-wired fa-lg",
    },
    {
      name: "Software Architecture & API Design",
      desc: (
        <>
          Define API specifications using OpenAPI 3.1 and JSON Schema.
          <br />
          Build clean, maintainable architectures that are easy to extend and integrate across services.
        </>
      ),
      icon: "fas fa-gears fa-lg",
    },
    {
      name: "Process Automation & Scripting",
      desc: (
        <>
          Automate workflows using Python, PowerShell, and UIPath.
          <br />
          Proven success in streamlining operations and improving productivity through intelligent scripting.
        </>
      ),
      icon: "fas fa-robot fa-lg",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Proficiency
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I can Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-lg rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      > 
                      {service.Icon ? (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 48,
                                height: 48,
                                color: iconColor,
                              }}
                            >
                              <service.Icon width="45" height="45" />
                            </span>
                          ) : (
                            <i className={service.icon} style={{ color: iconColor }} />
                          )}
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                        style={{
                          textAlign: "justify",
                          textJustify: "inter-word",
                          lineHeight: 1.6,
                        }}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
